import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { AppComponent } from "./app/app.component";
import {
  applyPendingSetPasswordAuthority,
  relocatePendingB2cRedirect,
} from "./app/auth.config";
import { isStaleChunkError, recoverFromStaleChunk } from "./app/core/stale-chunk";
import { environment } from "./environments/environment";

applyPendingSetPasswordAuthority();

if (relocatePendingB2cRedirect(environment.mslConfig.redirectUri)) {
  // Reloading on redirectUri so MSAL can consume the B2C response.
} else {
  bootstrapApplication(AppComponent, appConfig).catch((err) => {
    console.error(err);
    if (isStaleChunkError(err)) {
      recoverFromStaleChunk();
    } else {
      window.location.reload();
    }
  });
}

// Lazy imports that fail outside a router navigation (loadComponent in templates, dynamic imports).
window.addEventListener("unhandledrejection", (event) => {
  if (isStaleChunkError(event.reason)) {
    recoverFromStaleChunk();
  }
});
